"use client"

import React from 'react';
import styles from "./Liturgies.module.scss";
import {useAppStore} from "@/store/AppStore";
import useLiturgiesData from "@/utils/hooks/useLiturgiesData";
import {Liturgy} from "@/types/Liturgies";
import LoginAlert from "@/components/LoginAlert/LoginAlert";

export default function Liturgies(params: { currentId?: string }) {
  const {currentId} = params
  const user = useAppStore((state) => state.user);
  const data = useLiturgiesData(user?.access_token)
  const items = data?.items

  // `opened` deriva da `currentId` (formato `liturgy-<id>`). La
  // condizione `currentId.includes("liturgy")` e' gia' guardrail piu'
  // sotto: prima di li' il componente ritorna null.
  const opened = currentId?.includes("liturgy")
    ? Number(currentId.split("liturgy-")[1])
    : undefined


  if (!currentId) return null
  if (!currentId.includes("liturgy")) return null
  if (!user) return <LoginAlert/>

  const actives: Liturgy[] | undefined = opened ? items?.filter((itm) => {
    return itm.id === opened
  }) : undefined

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.contentWrapper}>
          {actives && actives.at(0) && <div>
            <h2 className={styles.prayerTitle}>{actives?.at(0)?.name}</h2>
            <div dangerouslySetInnerHTML={{__html: String(actives?.at(0)?.content)}}/>
          </div>
          }
        </div>
      </div>
    </div>
  )
}
